"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DurationFormatter;

var _moment = _interopRequireDefault(require("moment"));

var _momentDurationFormat = _interopRequireDefault(require("moment-duration-format"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

(0, _momentDurationFormat["default"])(_moment["default"]);

function DurationFormatter(_ref) {
  var _column$options;

  var row = _ref.row,
      column = _ref.column;
  var value = row[column.key];
  var format = ((_column$options = column.options) === null || _column$options === void 0 ? void 0 : _column$options.format) || "h:mm";
  return value !== undefined ? _moment["default"].duration(value, "seconds").format(format, {
    trim: false
  }) : null;
}